import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { MyContextProvider } from './globalContext';
import reportWebVitals from './reportWebVitals';
import { loadConfig, getConfig } from './loadconfig';
import Constants from './utils/Constants';
import AppDynamics from './AppDynamics'; // Import the AppDynamics component

const root = ReactDOM.createRoot(document.getElementById('root'));

const AppLoader = () => {
  const [configLoaded, setConfigLoaded] = useState(false);

  useEffect(() => {
    let config = getConfig();
    // Assuming loadConfig returns a promise
    // console.log( "tagmanager", Constants.GOOGLE_TAG_MANAGER + config.GATRACKID);
    loadConfig().then(() => {
      setConfigLoaded(true);
     
      const script = document.createElement('script');
      script.async = true;
      script.src = Constants.GOOGLE_TAG_MANAGER + config.GATRACKID;
      document.head.appendChild(script);

      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          console.log("data is pushed into data layer ",arguments);
          window.dataLayer.push(arguments);
        }
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', config.GATRACKID);
      };
    
    }).catch(error => {
      console.error('Failed to load config:', error);
      // Handle error or set a default state
    });
  }, []); // Empty dependency array means this runs once on mount

  if (!configLoaded) {
    return <div>Loading...</div>; // Or any other loading indicator
  }

  return (
    <MyContextProvider>
      <App />
      <AppDynamics /> 
    </MyContextProvider>
  );
};

root.render(
  // <React.StrictMode>
    <AppLoader />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
